import React, { lazy, Suspense, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import Container from 'components/Container/Container';
import ContainersCategory from 'pages/ContainersCategory/ContainersCategory';
import AppBar from 'components/layout/header/AppBar/AppBar';
import Loader from 'components/modules/Loader/Loader';
import Footer from 'components/layout/footer/Footer/Footer';
import PageNotFound from 'components/PageNotFound/PageNotFound';

const Homepage = lazy(() =>
  import(/* webpackChunkName: "Homepage" */ 'pages/Homepage/Homepage')
);
const Containers = lazy(() =>
  import(/* webpackChunkName: "Containers" */ 'pages/Containers/Containers')
);
const ContainersDetails = lazy(() =>
  import(
    /* webpackChunkName: "ContainersDetails" */ 'pages/ContainerDetails/ContainerDetails'
  )
);
const Cart = lazy(() =>
  import(/* webpackChunkName: "Cart" */ 'pages/Cart/Cart')
);

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  ScrollToTop();
  return (
    <>
      <Container>
        <AppBar />
      </Container>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Homepage />} />

          <Route
            path="containers"
            element={
              <Container>
                <Containers />
              </Container>
            }
          />
          <Route
            path="containers/:category"
            element={
              <Container>
                <ContainersCategory />
              </Container>
            }
          />
          <Route
            path="containers/:category/:container/*"
            element={
              <Container>
                <ContainersDetails />
              </Container>
            }
          />

          <Route
            path="cart"
            element={
              <Container>
                <Cart />
              </Container>
            }
          />

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
}
